<div class="number_of_records_container" cdkScrollable>
  <span class="body2-impaired">{{ 'MAT_PAGINATOR.NUMBER_OF_RECORDS' | translate }} </span>
  <app-select-impaired [optionListWidth]="81" (selectValueChanged)="setPageSize($event)" [selectOptions]="pageSizeOptions" [selectValue]="pageSizeOption">
    <app-button-icon [buttonName]="pageSizeOption.title"></app-button-icon>
  </app-select-impaired>
</div>

<span class="body2-impaired">
  {{ 'MAT_PAGINATOR.NUMBER_RECORDS' | translate }}: {{ pageSizeView }} {{ allCount && allCount !== pageSize ? 'из ' + allCount : '' }}
</span>

<div class="number_of_page_container">
  <app-impaired-icon [isIconDisabled]="!prevPageAccepted" (clickOnIcon)="toFirstPage()" [iconName]="icons.FirstPageImpaired"></app-impaired-icon>
  <app-impaired-icon [isIconDisabled]="!prevPageAccepted" (clickOnIcon)="toPrevPage()" [iconName]="icons.PrevPageImpaired"></app-impaired-icon>
  <input
    [disabled]="pageSize === -1 || (prevPageAccepted && nextPageAccepted)"
    (keypress)="numberOnly($event)"
    (focusout)="pageIndexChange(false)"
    type="number"
    (keydown.enter)="pageIndexChange(true)"
    name="pageIndex"
    [formControl]="pageIndexControl"
    class="body2-impaired number_of_page"
  />
  <app-impaired-icon [isIconDisabled]="!nextPageAccepted" (clickOnIcon)="toNextPage()" [iconName]="icons.NextPageImpaired"></app-impaired-icon>
  <app-impaired-icon [isIconDisabled]="!nextPageAccepted" (clickOnIcon)="toLastPage()" [iconName]="icons.LastPageImpaired"></app-impaired-icon>
</div>
